import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import MainLayout from './Layouts/MainLayout';

const SignInSide = React.lazy(() => import('./pages/SignInSide'));
const ListMyTraining = React.lazy(() => import('./pages/Training/ListMyTraining'));
const MyTrainingDetails = React.lazy(() => import('./pages/Training/MyTrainingDetails'));
const MySchedule = React.lazy(() => import('./pages/MySchedule'));
const ScheduleModality = React.lazy(() => import('./pages/SchedulingModality/ScheduleModality'));
const SchedulingConfirmation = React.lazy(() => import('./pages/SchedulingModality/SchedulingConfirmation'));
const SucessScheduling = React.lazy(() => import('./pages/SchedulingModality/SucessScheduling'));
const ErrorPage = React.lazy(() => import('./pages/ErrorPage'));
const ForgotPassword = React.lazy(() => import('./pages/Password/ForgotPassword'));
const ConfirmationPassword = React.lazy(() => import('./pages/Password/ConfirmationPassword'));
const MyProfile = React.lazy(() => import('./pages/MyProfile'));
const ActivateUser = React.lazy(() => import('./pages/ActivateUser'));
const WeeklySchedule = React.lazy(() => import('./pages/WeeklySchedule'));
const SelectOption = React.lazy(() => import('./pages/SelectOption'));

const AppRoutes = () => {

  return (
    <React.Suspense fallback={<h5>Aguarde...</h5>}>
      <Routes>
        <Route path="/" element={<Navigate to="/select-option" />} />
        <Route path="/login" element={<SignInSide />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/confirmation-password" element={<ConfirmationPassword />} />
        <Route path="/activate-user" element={<ActivateUser />} />
        <Route path="*" element={
          <PrivateRoute>
            <MainLayout>
              <Routes>
                <Route path="/select-option" element={<SelectOption />} />
                <Route path="/profile" element={<MyProfile />} />
                <Route path="/my-training" element={<ListMyTraining />} />
                <Route path="/training-details/:id" element={<MyTrainingDetails />} />
                <Route path="/schedule-modality" element={<ScheduleModality />} />
                <Route path="/scheduling-confirmation" element={<SchedulingConfirmation />} />
                <Route path="/schedule-modality" element={<ScheduleModality />} />
                <Route path="/sucess-scheduling" element={<SucessScheduling />} />
                <Route path="/my-schedule" element={<MySchedule />} />
                <Route path="/weekly-schedule" element={<WeeklySchedule />} />
                <Route path="*" element={<ErrorPage />} />
              </Routes>
            </MainLayout>
          </PrivateRoute>
        } />
      </Routes>
    </React.Suspense>
  );
};

export default AppRoutes;
